var _defs, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockerSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.45,
    height: 14.1,
    viewBox: "0 0 13.45 14.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#767571;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0V12.97H13.45V0H0ZM12.38,11.9H1.07V1.07H12.38V11.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.03,8.28c.3,0,.53-.24,.53-.53v-2.53c0-.3-.24-.53-.53-.53s-.53,.24-.53,.53v2.53c0,.3,.24,.53,.53,.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.68,4.14c.31,0,.57-.25,.57-.57s-.25-.57-.57-.57-.56,.25-.56,.57,.25,.57,.56,.57Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8.12,
    cy: 3.58,
    r: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.57,4.13c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.68,7.09c.31,0,.57-.25,.57-.57s-.25-.57-.57-.57-.56,.25-.56,.57,.25,.57,.56,.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.12,7.08c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.57,7.08c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.68,10.03c.31,0,.57-.25,.57-.57s-.25-.57-.57-.57-.56,.25-.56,.57,.25,.57,.56,.57Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.12,10.02c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.57,10.02c.3,0,.55-.25,.55-.55s-.25-.55-.55-.55-.55,.25-.55,.55,.25,.55,.55,.55Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.43,13c-.3,0-.55,.25-.55,.55s.25,.55,.55,.55,.55-.25,.55-.55-.25-.55-.55-.55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.02,13c-.3,0-.55,.25-.55,.55s.25,.55,.55,.55,.55-.25,.55-.55-.25-.55-.55-.55Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerSmall);
export default __webpack_public_path__ + "static/media/LockerSmall.60301b23f024dbe3aa2869c51b5f2309.svg";
export { ForwardRef as ReactComponent };